// extracted by mini-css-extract-plugin
export default {"check":"check__Fm22D","check__box":"check__box__cLg_Z"};